import { useContext, useEffect } from "react";
import MapContext from "../Map/MapContext";
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import { Icon, Style } from 'ol/style';
import { Vector as VectorLayer } from 'ol/layer';
import icone from '../assets/pictos/pointadresse.png'


const PointAdresse = ({ centreadresse }) => {

    const { map } = useContext(MapContext);


    useEffect(() => {
        if (map && centreadresse[0] !== 0 && centreadresse[1] !== 0) {

            const iconStyle = new Style({
                image: new Icon({
                    scale: 0.5,
                    anchor: [0.5, 1],
                    //anchorXUnits: 'fraction',
                    //anchorYUnits: 'pixels',
                    src: icone,
                }),
            });

            const iconFeature = new Feature({
                geometry: new Point(centreadresse),
            });


            iconFeature.setStyle(iconStyle);

            const vectorSource = new VectorSource({
                features: [iconFeature],
            });

            const vectorLayer = new VectorLayer({
                source: vectorSource,
            });

            map.addLayer(vectorLayer);

            if (!map) return;

            return () => {
                if (map) {
                    map.removeLayer(vectorLayer);
                }
            };
            // eslint-disable-next-line


        }

        // eslint-disable-next-line
    }, centreadresse);


    return null;
};

export default PointAdresse;